<template>
  <div>
    <!-- 辅料类别设置：先在弹框内增删改，最后统一保存 -->
    <el-dialog :title="$t('message.materialTypeSetting')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="820px" center v-loading="loading">
      <div class="content">
        <div class="row">
          <el-button type="success" size="small" @click="add">
            {{ $t('message.newCategoriesAdded') }}
          </el-button>
        </div>

        <div class="table">
          <ol>
            <!-- 类别名称 -->
            <li class="flex2">{{ $t('message.materialType') }}</li>
            <!-- 类别译文名 -->
            <li class="flex2">{{ $t('message.materialNameTrans') }}</li>
            <!-- 操作 -->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="item._key">
            <li class="flex2">
              <el-input v-model.trim="item.name" :placeholder="$t('message.materialType')" clearable />
            </li>
            <li class="flex2">
              <el-input v-model.trim="item.name_trans" :placeholder="$t('message.materialNameTrans')" clearable />
            </li>
            <li>
              <el-button type="success" size="small" class="dark" @click="deleteItem(index)">
                {{ $t('message.delete') }}
              </el-button>
            </li>
          </ul>
          <div v-if="!tableData.length" class="empty">-</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button type="primary" :loading="saveLoading" @click="save">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MaterialTypeSetting',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      // 弹框内的临时类别列表，保存前的新增、编辑、删除只修改这里
      tableData: [],
      // 新增行还没有 id，用本地 key 避免 v-for key 重复
      keyIndex: 1
    }
  },
  methods: {
    // 打开弹框并重新拉取最新类别列表
    open() {
      this.dialogVisible = true
      this.getList()
    },
    // 查询辅料类别列表，并补齐弹框编辑所需字段
    getList() {
      this.loading = true
      this.$api.warehouseApi.materialTypeList().then(res => {
        const list = res.data || []
        this.tableData = list.map(item => ({
          id: item.id,
          name: item.name || '',
          name_trans: item.name_trans || '',
          _key: item.id || this.getKey()
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    // 生成未保存行的临时 key
    getKey() {
      return `new_${this.keyIndex++}`
    },
    // 新增一行空类别，保存时随最终列表一起提交
    add() {
      this.tableData.push({
        id: '',
        name: '',
        name_trans: '',
        _key: this.getKey()
      })
    },
    // 删除只影响弹框临时列表，真正删除由保存接口按最终列表统一处理
    deleteItem(index) {
      this.$confirm(this.$t('message.areYouSureToDelete'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.ok'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning'
      }).then(() => {
        this.tableData.splice(index, 1)
      }).catch(() => { })
    },
    // 批量保存最终类别列表，提交字段：id、name、name_trans
    save() {
      const list = this.tableData.map(item => ({
        id: item.id,
        name: item.name,
        name_trans: item.name_trans
      })).filter(item => item.name && item.name_trans)

      if (list.length !== this.tableData.length) {
        this.$message.warning(this.$t('message.TheRequired'))
        return
      }

      this.saveLoading = true
      this.$api.warehouseApi.materialTypeBatchSave({ list }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$emit('saved')
      }).finally(() => {
        this.saveLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 15px 30px;

  .row {
    margin-bottom: 20px;
    text-align: right;
  }

  .table {
    border: 1px solid #edeff4;

    ol,
    ul {
      display: flex;
      padding: 0;
      margin: 0;
      list-style: none;
    }

    ol {
      background: #edeff4;
      font-weight: 600;
    }

    ul {
      border-top: 1px solid #edeff4;
    }

    li {
      flex: 1;
      padding: 16px;
      text-align: center;
      border-right: 1px solid #edeff4;
      box-sizing: border-box;

      &:last-child {
        border-right: 0;
      }
    }

    .flex2 {
      flex: 3;
    }

    .empty {
      padding: 24px;
      color: #999;
      text-align: center;
      border-top: 1px solid #edeff4;
    }
  }

  /deep/.el-input {
    width: 80%;
  }
}
</style>
